import moment from 'moment';

/**
 * Class for handling date range presets and associated calculations
 */
export class DateRangeCalculator {
	/**
	 * Get the list of names of known presets
	 * @returns {String[]}
	 */
	static getPresetNames() {
		return [
			'Last 7 days',
			'Last 30 days',
			'This calendar week',
			'Last calendar week',
			'This calendar month',
			'Last calendar month',
		];
	}

	/**
	 * Run the preset with the given name
	 * @param {String} presetName  The name such as "Last 7 days"
	 * @returns {moment[]}  An Array with start and end date
	 */
	static runPreset(presetName) {
		let fn = (presetName || '').toLowerCase().replace(/ (\w)/g, ($0, $1) => $1.toUpperCase());
		return this[fn] ? this[fn]() : [];
	}

	/**
	 * Get the results of all available presets
	 *
	 * @return {Object}  follows this format: {'preset name': preset result}
	 */
	static getPresets() {
		return {
			'Last 7 days': this.last7Days(),
			'Last 30 days': this.last30Days(),
			'This calendar week': this.thisCalendarWeek(),
			'Last calendar week': this.lastCalendarWeek(),
			'This calendar month': this.thisCalendarMonth(),
			'Last calendar month': this.lastCalendarMonth(),
		};
	}

	/**
	 * Return range of last 6 days plus today until end of day
	 * @returns {moment[]}  An Array with start and end date
	 */
	static last7Days() {
		return [moment().startOf('day').subtract(6, 'days'), moment().endOf('day')];
	}

	/**
	 * Return range of last 29 days plus today until end of day
	 * @returns {moment[]}  An Array with start and end date
	 */
	static last30Days() {
		return [moment().startOf('day').subtract(29, 'days'), moment().endOf('day')];
	}

	/**
	 * Return range of last Sunday through now and until Saturday
	 * @returns {moment[]}  An Array with start and end date
	 */
	static thisCalendarWeek() {
		return [moment().startOf('week'), moment().endOf('week')];
	}

	/**
	 * Return range of two Sundays ago through Saturday
	 * @returns {moment[]}  An Array with start and end date
	 */
	static lastCalendarWeek() {
		return [moment().subtract(1, 'week').startOf('week'), moment().subtract(1, 'week').endOf('week')];
	}

	/**
	 * Return range of first of month through now and until end of month
	 * @returns {moment[]}  An Array with start and end date
	 */
	static thisCalendarMonth() {
		return [moment().startOf('month'), moment().endOf('month')];
	}

	/**
	 * Return range of first of last month through end of month
	 * @returns {moment[]}  An Array with start and end date
	 */
	static lastCalendarMonth() {
		return [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')];
	}
}
